import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import AccountCircle from '@mui/icons-material/AccountCircle';

const poteamid = localStorage.getItem('poteamid');

interface HeaderProps {
    onDrawerToggle: () => void;
}

export default function Header(props: HeaderProps) {
    const { onDrawerToggle } = props;

    return (
        <React.Fragment>
            <AppBar color="primary" position="sticky" elevation={0} sx={{ background: '#0D0D0D' }}>
                <Toolbar>
                    <Grid container spacing={1} alignItems="center">
                        <Grid sx={{ display: { sm: 'none', xs: 'block' } }} item>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={onDrawerToggle}
                                edge="start"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs />
                        {(poteamid != null && poteamid !== '' && poteamid !== 'null') && (
                            <>
                                <Grid item>
                                    <Tooltip title="Alerts • No alerts">
                                        <IconButton color="inherit">
                                            <NotificationsIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item>
                                    <Link to="/profile" className='navlink'>
                                        <IconButton color="inherit" sx={{ p: 0.5 }}>
                                            <AccountCircle />
                                        </IconButton>
                                    </Link>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Toolbar>
            </AppBar>

        </React.Fragment>
    );
}